import Folders from '../components/Folders/FoldersList'
import Dashboard from '../components/Dashboard/Dashboard'

const routes = [
  {
    path: '',
    name: 'disk.folders',
    component: Folders
  },
  {
    path: 'dashboard',
    name: 'disk.dashboard',
    component: Dashboard
  },
]

export default routes



// WEBPACK FOOTER //
// ./src/apps/disk/router/routes.js